import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/meta";

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full bg-primary-950 text-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-clapperboard-line text-xl" />
              </span>
              <span className="font-heading text-xl font-extrabold text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              {siteInfo.intro}
            </p>
            <p className="mt-4 inline-flex items-center gap-2 rounded-md bg-primary-900 px-3 py-2 text-xs text-accent-300">
              <i className="ri-information-line text-base" />
              本站内容均为演示数据，播放与收藏功能仅为前端展示
            </p>
          </div>

          <div>
            <h2 className="font-heading text-sm font-bold uppercase tracking-wider text-background-50">
              内容导航
            </h2>
            <ul className="mt-4 space-y-3 text-sm text-background-300">
              <li>
                <Link to="/category/movie" className="transition-colors hover:text-accent-400">
                  电影分类
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="transition-colors hover:text-accent-400">
                  电视剧分类
                </Link>
              </li>
              <li>
                <Link to="/search" className="transition-colors hover:text-accent-400">
                  影视搜索
                </Link>
              </li>
              <li>
                <Link to="/about" className="transition-colors hover:text-accent-400">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-sm font-bold uppercase tracking-wider text-background-50">
              联系我们
            </h2>
            <ul className="mt-4 space-y-3 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-accent-400" />
                {siteInfo.email}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-weibo-line text-base text-accent-400" />
                {siteInfo.weibo}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-base text-accent-400" />
                {siteInfo.address}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-primary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} {siteInfo.name} · 保留所有权利</p>
          <p>{siteInfo.icp}</p>
        </div>
      </div>
    </footer>
  );
}